import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Button} from 'react-bootstrap';
import { BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import 'react-toastify/dist/ReactToastify.css';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const PemakaianVentilator = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [listRiwayatPemakaianVentilator,setListRiwayatPemakaianVentilator] =useState([]);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            const promise1 = await VedikaService.riwayatPakaiVentilator(`norec_pd=${$('#norecPd').val()}`);
            const allPromise = await  Promise.all([promise1]);
            setListRiwayatPemakaianVentilator(allPromise[0].data.data)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }

    const loadDTRiwayatPakaiVentilator = () => {
        // return console.log(res);
        $('#dtRiwayatPakaiVentilator').DataTable({
            data: listRiwayatPemakaianVentilator,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: 'tanggal_pasang',
                    render: function (data, type, row, meta) {
                        let result = '';
                        result = `${row.tanggal_pasang}<br/>${row.nama_peg_create}`;
                        return result;
                    },
                    width:'15%',
                },
                {
                    targets: [1],
                    data: 'tanggal_lepas',
                    render: function (data, type, row, meta) {
                        let result = '';
                        if([null,''].includes(data)){
                            result = '-';
                        }else{
                            result = `${row.tanggal_lepas}<br/>${row.nama_peg_mod}`;
                        }
                        return result;
                    },
                    width:'15%',
                },
                {
                    targets: [2],
                    data: 'flow_ventilator',
                    render: function (data, type, row, meta) {
                        return [null,''].includes(data)  ? '-' : data;
                    },
                    width:'25%',
                },
                {
                    targets: [3],
                    data: 'ruangan_pasang',
                    render: function (data, type, row, meta) {
                        return [null,''].includes(data) ? '-' : data;
                    },
                    width:'25%',
                },
                {
                    targets: [4],
                    data: 'mode_ventilator',
                    render: function (data, type, row, meta) {
                        return [null,''].includes(data) ? '-' : data;
                    },
                    width:'20%',
                },
            ]
        })
    }

    useEffect(()=>{
        loadDTRiwayatPakaiVentilator ();
    },[listRiwayatPemakaianVentilator])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Riwayat Pemakaian Ventilator</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/ventilator/${$('#norec').val()}`} style={{ textDecoration: 'none',color:'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtRiwayatPakaiVentilator' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th>Tanggal Pasang</th>
                                <th>Tanggal Lepas</th>
                                <th>Flow</th>
                                <th>Ruangan</th>
                                <th>Mode Ventilator</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PemakaianVentilator;